import axios from '../../../axios';
import IRecruiterMonsterAccount from '../types/IRecruiterMonsterAccount';

const url = '/api/recruiter-monster-account';

const urlMonsterPosting = '/jobsearch/api/jobs/post-to-monster';

export const getMonsterAccount = (id: string) => axios.post(`${url}/${id}`);

export const saveMonsterAccount = (monsterAccount: IRecruiterMonsterAccount) =>
  axios.post(`${url}`, monsterAccount);

export const postToMonster = (
  jobIds: string,
  monsterAccountId: string,
  attributeSettings: string,
  monsterJobLocation: {
    city: string | null;
    state: string | null;
    country: string | null;
  }
) =>
  axios.post(
    `${urlMonsterPosting}/${jobIds}/${monsterAccountId}?settings=${encodeURIComponent(
      attributeSettings
    )}`,
    monsterJobLocation
  );

export const setMonsterInventory = (
  id: string,
  jobduration: string,
  autorefresh: string,
  can: string
) => axios.get(`${url}/set-inventory/${id}/${jobduration}/${autorefresh}/${can}`);

export const getMonsterInventory = (id: string) => axios.get(`${url}/get-inventory/${id}`);

export const deleteMonsterAccount = (id: string) => axios.delete(`${url}/delete/${id}`);
